import { render, staticRenderFns } from "./OrganizationProfileStatusTag.vue?vue&type=template&id=2ef66215"
import script from "./OrganizationProfileStatusTag.vue?vue&type=script&lang=js"
export * from "./OrganizationProfileStatusTag.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2ef66215')) {
      api.createRecord('2ef66215', component.options)
    } else {
      api.reload('2ef66215', component.options)
    }
    module.hot.accept("./OrganizationProfileStatusTag.vue?vue&type=template&id=2ef66215", function () {
      api.rerender('2ef66215', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/erp/components/OrganizationProfileStatusTag.vue"
export default component.exports